import { Component, OnInit, OnDestroy, Inject, ChangeDetectorRef } from '@angular/core';
import { BasePageComponent } from '../../base-page';
import { IPageData } from 'src/app/interfaces/page-data';
import { Spinkit } from 'ng-http-loader';
import { Subject } from 'rxjs';
import { IAppState } from 'src/app/interfaces/app-state';
import { Store } from '@ngrx/store';
import { HttpService } from 'src/app/services/http/http.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MatBottomSheet, MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import Swal from 'sweetalert2';
import * as PageActions from '../../../store/actions/page.actions';
import { Location } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { LoginService } from 'src/app/layout/components/login-form/login-form.service';
import { environment } from 'src/environments/environment';
import { MapsAPILoader } from '@agm/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import swal from 'sweetalert2'
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-usersresto-list',
  templateUrl: './usersresto-list.component.html',
  styleUrls: ['./usersresto-list.component.scss']
})
export class UsersrestoListComponent extends BasePageComponent implements OnInit, OnDestroy {
  pageData: IPageData;
  value: number = 0;
  public spinkit = Spinkit;
  restoID
  ids
  UserCondition
  token
  restoCondition
  tableids
  allrestaurant
  spice_rating_all
  diestPrefArrayName
  diestPrefArray
  UserCC
  searchText
  decode
  decodetableID
  online_Status
  lat
  lng

  geoCoder
  encodeUrl_origin
  encodeUrl_destination
  currentLocation
  address
  lat_resto
  lng_resto
  restoId
  allergenceArrayName
  panelOpenState = false;
  public totalSubject = new Subject()
  public orderSubject = new Subject()
  allergenceArray: any;
  iconmenu = './assets/img/menu.svg';
  iconAtvmenu = './assets/img/greymenu.svg';

  iconcart = './assets/img/green_cart.svg';
  iconAtvcart = './assets/img/cart.svg';

  iconorder = './assets/img/green_orders.svg';
  iconAtvorder = './assets/img/order.svg';

  iconprofile = './assets/img/greenprofile.svg';
  iconAtvprofile = './assets/img/profile.svg';
  constructor(store: Store<IAppState>,
    public httpSv: HttpService,
    private router: Router,
    public loginservice: LoginService,
    private route: ActivatedRoute,
    private _bottomSheet: MatBottomSheet,
    private mapsAPILoader: MapsAPILoader,
    private changeDetectorRef: ChangeDetectorRef,
    private _snackBar: MatSnackBar,
    public dialog: MatDialog,
    private _location: Location) {
    super(store, httpSv);
    this.pageData = {
      title: '',
      loaded: true,
      breadcrumbs: [
        {
          title: '',
          route: 'resto'
        }
      ]
    };
  }
  restoConditions
  ngOnInit() {
    this.restoConditions = "1";
    this.getCategory()
    this.getAllCuisines()
    sessionStorage.removeItem("orders-data");
    sessionStorage.removeItem("FianlArray");
    sessionStorage.removeItem("count");
    sessionStorage.removeItem("addon-orders");
    this.restoID = sessionStorage.getItem("restoId")
    this.token = sessionStorage.getItem('access_token')
    this.ids = sessionStorage.getItem('restoIds')
    this.online_Status = sessionStorage.getItem('onlineStatus')
    this.tableids = sessionStorage.getItem('tableIds')
    this.lat = sessionStorage.getItem('lat');
    this.lng = sessionStorage.getItem('lng');
    this.userCurrentLocations = sessionStorage.getItem('visitorOrigin');
    if (this.userCurrentLocations) {
      this.userCurrentLocation = true;
    } else {
      this.userCurrentLocation = false;
    }
    this.route.queryParams.subscribe(params => {
      this.UserCondition = sessionStorage.getItem('access_token') ? true : false;
      // if (this.online_Status == 'Active') {
      //   // this.restaurant_online();
      // } else if(this.lat && this.lng) {
      //     // this.restaurant_offline();
      // }
      //   else {
      //     // this.restaurantAll();
      //   }

      // if (this.lat && this.lng) {
      //   this.latitude = this.lat;
      //   this.longitude = this.lng
      //   this.getOfflineRestaurant()
      // } else {
      //   let sheetRef = this._bottomSheet.open(BottomSheetuserCurrentLocation, {
      //     disableClose: true
      //   });
      //   sheetRef.afterDismissed().subscribe((dataFromChild) => {
      //     if (dataFromChild.code === 1) {
      //       this.userCurrentLocation = true;
      //       this.userCurrentLocations = dataFromChild.message;
      //       const dialogRef = this.dialog.open(UserLocationPermission, {
      //         width: "321px",
      //         height: "163px"
      //       });

      //     } else {
      //       this.userCurrentLocation = true;
      //       this.userCurrentLocations = dataFromChild;
      //     }
      //   })
      //   this.getLocation();
      //   this.getOfflineRestaurant()
      // }

    });
    this.pageData ? this.store.dispatch(new PageActions.Set(this.pageData)) : null;
    this.mapsAPILoader.load().then(() => {
      this.geoCoder = new google.maps.Geocoder;
    });
    //  this.getOfflineRestaurant()
  }
  images = [
    { path: 'https://source.unsplash.com/800x600/?nature' },
    { path: 'https://source.unsplash.com/800x600/?car' },
    { path: 'https://source.unsplash.com/800x600/?moto' },
    { path: 'https://source.unsplash.com/800x600/?fantasy' },
  ]

  private destroyed = false;
  ngOnDestroy() {
    this.destroyed = true;
    this.store.dispatch(new PageActions.Reset());
    this.changeDetectorRef.detach();
  }
  // ngAfterViewInit(): void {
  //   //Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
  //   //Add 'implements AfterViewInit' to the class.
  //  setTimeout(()=>{
  //   let h = document.getElementById('back-mobile-img')
  //   console.log(h,h.clientWidth)
  //   document.getElementById('div-cointainer').style.width = `${h.clientWidth}px`
  //  },100)
  // }

  triggerChangeDetection() {
    if (!this.destroyed) {
      this.changeDetectorRef.detach();
      this.changeDetectorRef.detectChanges();
      this.changeDetectorRef.detach();
    }
  }
  filterToggele = false
  showCatFilter() {
    this.filterToggele = !this.filterToggele
    if (this.filterToggele)
      document.getElementById('cat-filter-arrowImg').style.transform = 'rotate(180deg)'
    else
      document.getElementById('cat-filter-arrowImg').style.transform = 'rotate(0deg)'
  }
  outsideClick(hasClickedOutside){
    if(hasClickedOutside){
      if(this.filterToggele){
      this.filterToggele = false
      document.getElementById('cat-filter-arrowImg').style.transform = 'rotate(0deg)'
      }
    }
  }
  backTologin() {
    this.router.navigate(['/public/sign-in']);
  }

  showAllResto: boolean = false;
  showAllRestos() {
    this.showAllResto = true;
  }

  gotoRestos() {
    this.restoConditions = "1";
    this.searchText = '';
    this.showFilteredResto = false;
  }

  showFilteredResto: boolean = false
  checkFiletered(e) {
    if (e.length >= 3) {
      this.showFilteredResto = true;
    } else {
      this.showFilteredResto = false;
    }
  }
  gotoResto() {
    this.showAllResto = false;
    this.getOfflineRestaurant();
    this.categoryCheckList = []
    this.cuisineCheckList = []
    this.conditionCatFilter = false
    this.conditionCusineFilter = false
  }

  restaurant_online() {
    this.httpSv.restaurant_online().subscribe(
      response => {
        if (response['status'] == true) {
          this.allrestaurant = response['result'].data
          this.restoCondition = "3"
        }
        if (response['status'] == false) {
          this.restoCondition = "2"
        }
      },
      (err: HttpErrorResponse) => {
        this.restoCondition = "2";
      }
    )
  }
  restaurant_offline() {
    this.httpSv.restaurant_offline_user(this.lat, this.lng).subscribe(
      response => {
        if (response['status'] == true) {
          // this.allrestaurant = response['result'].data
          let allresto = response['result'].data;
          // response['result'].data[0].visitorOrigin = null;
          let location: any = allresto.filter((data) => {
            return ((data.duration != null && data.duration != undefined) || (data.distance != null && data.distance != undefined));
          })
          let no_location: any = allresto.filter((data) => {
            return (data.duration == null || data.duration == undefined || data.distance == null || data.distance == undefined);
          })
          this.allrestaurant = [...location, ...no_location];
          this.restoCondition = "1"
        }
        if (response['status'] == false) {
          this.restoCondition = "2"
        }
      },
      (err: HttpErrorResponse) => {
        this.restoCondition = "2";
      }
    )
  }

  logout() {
    this.httpSv.logouts(this.token).subscribe(
      response => {
        if (response['status'] == true) {
          sessionStorage.clear();
          this.router.navigate(['public/resto'], {
            queryParams: {
              id: this.ids,
              table_id: this.tableids
            }
          });
        } else {
          // this.resetFormLoad = false;
          Swal.fire("Something Went Wrong")
        }

      }
    )
  }

  getCategoryFilter(catId) {
    if (this.latitude && this.longitude) {
      this.httpSv.getAllFilteredCategories(this.latitude, this.longitude, catId).subscribe((res: any) => {
        this.allrestaurant = res['result'].data;
        this.showAllResto = true;
      }, (err: any) => {
        console.log(err);
        if (err.status == 401 || err.status == 500) {
          this.logout();
        }
        this.showAllResto = false;
        this._snackBar.open("No Restaurants Found!");
        setTimeout(() => {
          this._snackBar.dismiss();
        }, 2000);
      })
    } else {
      this.httpSv.getFilteredCategories(catId).subscribe((res: any) => {
        this.allrestaurant = res['result'].data;
        this.showAllResto = true;
      }, (err: any) => {
        if (err.status == 401 || err.status == 500) {
          this.logout();
        }
        console.log(err);
        this.showAllResto = false;
        this._snackBar.open("No Restaurants Found!");
        setTimeout(() => {
          this._snackBar.dismiss();
        }, 2000);
      })
    }
  }

  getCuisineFilter(cuisineId) {
    if (this.latitude && this.longitude) {
      this.httpSv.getAllFilteredCuisine(this.latitude, this.longitude, cuisineId).subscribe((res: any) => {
        this.allrestaurant = res['result'].data;
        this.showAllResto = true;
      }, (err: any) => {
        if (err.status == 401 || err.status == 500) {
          this.logout();
        }
        console.log(err)
        this.showAllResto = false;
        this._snackBar.open("No Restaurants Found!");
        setTimeout(() => {
          this._snackBar.dismiss();
        }, 2000);
      })
    } else {
      this.httpSv.getFilteredCusine(cuisineId).subscribe((res: any) => {
        this.allrestaurant = res['result'].data;
        this.showAllResto = true;
      }, (err: any) => {
        if (err.status == 401 || err.status == 500) {
          this.logout();
        }
        console.log(err)
        this.showAllResto = false;
        this._snackBar.open("No Restaurants Found!");
        setTimeout(() => {
          this._snackBar.dismiss();
        }, 2000);
      })
    }
  }

  onLink_online(id) {
    sessionStorage.setItem("restoIds", id)
    this.decode = atob(id)
    sessionStorage.setItem('restoId', this.decode)
    sessionStorage.setItem('restoIDCopy', this.decode);
    this.getPreferencereference()
  }
  onLink(id, tableid, visitorOrigin) {
    if (this.UserCondition) {
      this.router.navigate(['/horizontal/food-menu'])
    } else {
      this.router.navigate(['/public/food-menu-guest'])
    }
    sessionStorage.setItem("restoIds", id)
    sessionStorage.setItem("tableIds", tableid)
    sessionStorage.setItem("visitorOrigin", visitorOrigin)
    if (parseInt(id)) {
      this.decode = id
    } else
      this.decode = atob(id)
    this.decodetableID = atob(tableid)
    sessionStorage.setItem('restoId', this.decode)
    sessionStorage.setItem('restoIDCopy', this.decode);
    sessionStorage.setItem('tableId', this.decodetableID)
  }
  visitorOrigin
  resto_id_value
  recordLocation_user() {
    this.visitorOrigin = sessionStorage.getItem('visitorOrigin')
    this.resto_id_value = sessionStorage.getItem('restoId');
    this.httpSv.recordLocation_user(this.resto_id_value, this.lat, this.lng, this.visitorOrigin).subscribe(res => {
      if (res['status'] == true) {
      }
    })
  }
  getPreferencereference() {
    this.httpSv.getUserPreference().subscribe(res => {
      if (res['status'] == true) {
        if (res['result'].data.allergens.length || res['result'].data.dietary.length) {
          if (res['result'].data.allergens && res['result'].data.allergens.length) {
            this.allergenceArray = res['result'].data.allergens
            this.spice_rating_all = res['result'].data.spice_rating_all
            this.UserCC = res['result'].data.cross_contamination
            sessionStorage.setItem("spiceRating", this.spice_rating_all)
            sessionStorage.setItem("selectedAlleregence", this.allergenceArray.toString())
            this.allergenceArrayName = res['result'].data.allergens_name
            sessionStorage.setItem("allergenceArrayName", this.allergenceArrayName.toString())
          }
          if (res['result'].data.dietary && res['result'].data.dietary.length) {
            this.diestPrefArray = res['result'].data.dietary
            sessionStorage.setItem("selectedDiestpref", this.diestPrefArray.toString())
            this.diestPrefArrayName = res['result'].data.dietary_name
            sessionStorage.setItem("diestPrefArrayName", this.diestPrefArrayName.toString())
          }
          this.router.navigate(['horizontal/food-menu']);
        } else {
          this.router.navigate(['/horizontal/choose-preference']);
        }
      }
    }, err => {
      this.router.navigate(['/horizontal/choose-preference']);
    })
  }
  backClicked() {
    this._location.back();
  }
  get_direction(id, lat_value, lng_value, origin, destination): void {
    this.restoId = atob(id);
    this.lat_resto = parseFloat(lat_value)
    this.lng_resto = parseFloat(lng_value)
    this.encodeUrl_origin = encodeURI(origin);
    if (!destination && destination != 'undefine') {
      this.geoCoder.geocode({ "location": { lat: this.lat_resto, lng: this.lng_resto } }, (results, status) => {
        if (results[0]) {
          this.address = results[0].formatted_address;
          this.encodeUrl_destination = encodeURI(this.address);
          window.open(environment.googleDirectionKey + 'origin=' + this.encodeUrl_origin + '&destination=' + this.encodeUrl_destination);
          if (this.UserCondition) {
            this.httpSv.recordDestination_user(this.restoId, this.address).subscribe(res => {
              if (res['status'] == true) {
              }
            })
          }
          else {
            this.httpSv.recordDestination_guest(this.restoId, this.address).subscribe(res => {
              if (res['status'] == true) {
              }
            })
          }

        } else {
          window.alert("No results found.");
        }
      });
    }
    else {
      this.encodeUrl_destination = encodeURI(destination);
      window.open(environment.googleDirectionKey + 'origin=' + this.encodeUrl_origin + '&destination=' + this.encodeUrl_destination);
    }
  };
  cuisineArray = []
  cuisineImages = []
  categoryArray = []
  mainCategoryArray = []
  categoryType = []
  categoryWithoutType = []
  showMoreFalg = false;
  showMoreCondition = false;
  getCategory() {
    this.httpSv.getAllCategories().subscribe((res: any) => {
      let temp = res.result.data
      temp.forEach(element => {
        this.categoryType.push(element.type)
        element.category.forEach(ele => {
          this.categoryWithoutType.push(ele)
        })
      });
      let sorted = this.categoryWithoutType.sort((a, b) => {
        if (a.display_order === b.display_order) {
          return 0;
        }

        // nulls sort after anything else
        if (a.display_order === null) {
          return 1;
        }
        if (b.display_order === null) {
          return -1;
        }

        // otherwise, if we're ascending, lowest sorts first
        return parseInt(a.display_order) < parseInt(b.display_order) ? -1 : 1;
      })
      this.categoryWithoutType = sorted.map(ele => ele)
      this.mainCategoryArray = res.result.data;
      if (this.categoryWithoutType.length > 11) {
        for (let i = 0; i < 12; i++) {
          this.categoryArray.push(this.categoryWithoutType[i])
        }
        this.showMoreFalg = true;
        this.showMoreCondition = true;
      } else {
        this.categoryArray = this.categoryWithoutType
        this.showMoreCondition = false;
        this.showMoreFalg = false;
      }
    }, (err: any) => {
      console.log(err)
      if (err.status == 401 || err.status == 500) {
        this.logout();
      }
    })
  }
  showMoreFunc() {
    this.categoryArray = this.categoryWithoutType
    this.showMoreFalg = false;
  }
  showLessFunc() {
    this.categoryArray = []
    for (let i = 0; i < 12; i++) {
      this.categoryArray.push(this.categoryWithoutType[i])
    }
    this.showMoreFalg = true;
  }
  selectedFilter = []
  filterSelectFunc(name, event) {
    if (event.checked) {
      this.selectedFilter.push(name)
    }
    else {
      let reqIndex = this.selectedFilter.findIndex(ele => ele == name)
      this.selectedFilter.splice(reqIndex, 1)
    }
    this.showFilterCatFunc()
  }
  filterCrossFunc(name) {
    let reqIndex = this.selectedFilter.findIndex(ele => ele == name)
    this.selectedFilter.splice(reqIndex, 1)
    this.showFilterCatFunc()
  }
  showFilterCatFunc() {
    this.categoryArray = []
    if (this.selectedFilter.length > 0) {
      this.selectedFilter.forEach(ele => {
        this.mainCategoryArray.forEach(element => {
          if (element.type == ele) {
            element.category.forEach(item => {
              this.categoryArray.push(item)
            })
          }
        })
      })
    }
    else {
      if (this.categoryWithoutType.length > 11) {
        for (let i = 0; i < 12; i++) {
          this.categoryArray.push(this.categoryWithoutType[i])
        }
        this.showMoreFalg = true;
        this.showMoreCondition = true;
      } else {
        this.categoryArray = this.categoryWithoutType
        this.showMoreCondition = false;
        this.showMoreFalg = false;
      }
    }
  }
  catFilterPreCheck(name) {
    if (this.selectedFilter.includes(name)) return true
    else false
  }
  mainCuisineArray
  showMoreCatFalg
  showMoreCatCondition
  getAllCuisines() {
    this.httpSv.getAllCuisines().subscribe((res: any) => {
      this.mainCuisineArray = res['result'].data;
      if (this.mainCuisineArray.length > 12) {
        for (let i = 0; i < 12; i++) {
          this.cuisineArray.push(this.mainCuisineArray[i])
        }
        this.showMoreCatFalg = true;
        this.showMoreCatCondition = true;
      } else {
        this.cuisineArray = this.mainCategoryArray
        this.showMoreCatCondition = false;
        this.showMoreCatFalg = false;
      }
      this.cuisineImages = this.cuisineArray.map(item => ({
        path: item.image,
        index: 5
      }))
    }, (err: any) => {
      console.log(err);
      if (err.status == 401 || err.status == 500) {
        this.logout();
      }
    })
  }
  showMoreCatFunc() {
    this.cuisineArray = this.mainCuisineArray
    this.showMoreCatFalg = false;
  }
  showLessCatFunc() {
    this.cuisineArray = []
    for (let i = 0; i < 12; i++) {
      this.cuisineArray.push(this.mainCuisineArray[i])
    }
    this.showMoreCatFalg = true;
  }

  longitude
  latitude
  userCurrentLocation
  restoOne = []
  restoTwo = []
  restoThree
  restoFour
  restoSix
  restoFive
  restoSeven
  combinedResto = []
  getOfflineRestaurant() {
    if (this.latitude && this.longitude) {
      this.httpSv.getAllOfflineRestaurants(this.latitude, this.longitude).subscribe((res: any) => {
        if (res['status'] == "TRUE") {
          this.userCurrentLocations = res.result.data[0].visitorOrigin;
          sessionStorage.setItem('userLocation', this.userCurrentLocations);
          sessionStorage.setItem('visitorOrigin', this.userCurrentLocations)
          this.allrestaurant = res['result'].data;
        }
      }, (err: any) => {
        console.log(err)
        if (err.status == 401 || err.status == 500) {
          this.logout();
        }
      })
    } else {
      this.httpSv.getRestoWithoutLocation().subscribe((res: any) => {
        if (res['status'] == "TRUE") {
          this.restoCondition = "2"
          this.allrestaurant = res['result'].data;
          this.userCurrentLocations = res.result.data[0].visitorOrigin;
          sessionStorage.setItem('userLocation', this.userCurrentLocations);
          sessionStorage.setItem('visitorOrigin', this.userCurrentLocations)
        }
      }, (err: any) => {
        console.log(err)
        if (err.status == 401 || err.status == 500) {
          this.logout();
        }
      })
    }
  }

  getLocation() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position: Position) => {
        if (position) {
          this.lat = position.coords.latitude;
          this.lng = position.coords.longitude;

          sessionStorage.setItem('lat', this.lat);
          sessionStorage.setItem('lng', this.lng);
          this.httpSv.getAllOfflineRestaurants(this.lat, this.lng).subscribe((res: any) => {
            if (res['status'] == "TRUE") {
              this.restoCondition = "2"
              this.allrestaurant = res['result'].data;
              this.restoOne = this.allrestaurant.slice(0, 1);
              this.restoTwo = this.allrestaurant.slice(1, 2);
              this.userCurrentLocations = res.result.data[0].visitorOrigin;
            }
          }, (err: any) => {
            console.log(err)
          })
        }
      },
        (error: PositionError) => {
          this.getOfflineRestaurant();
        });
    } else {
      swal.fire("Geolocation is not supported by this browser.");
    }
  }

  goToSearchPage() {
    this.restoConditions = "2";
    // this.showAllResto = true
  }
  userCurrentLocations
  openLocationMap() {
    this.lat = sessionStorage.getItem('lat');
    this.lat = parseFloat(this.lat);
    this.lng = sessionStorage.getItem('lng')
    this.lng = parseFloat(this.lng)
    this.restoConditions = "3";
    let data = {
      userCurrentLocation: this.userCurrentLocations,
    }

    let sheetRef = this._bottomSheet.open(BottomSheetConfirmLocation, {
      data: data,
      disableClose: true
    });

    sheetRef.afterDismissed().subscribe((dataFromChild) => {
      this.userCurrentLocations = dataFromChild;
      sessionStorage.setItem("userLocation", this.userCurrentLocations)
      this.restoConditions = "1";
      this.userCurrentLocation = true;
    });
    // let sheetRef = this._bottomSheet.open(BottomSheetConfirmLocation);
    // this.router.navigate(['/public/user-location'])
  }
  markerDragEnd($event: MouseEvent) {
    console.log($event);
    // this.latitude = $event.coords.lat;
    // this.longitude = $event.coords.lng;
    // this.getAddress(this.latitude, this.longitude);
  }

  nextSlide() {
    let test = document.getElementById('scrollContainer')
    let item = document.getElementById('scrollContainer').children
    test.append(item[0])
  }
  prevSlide() {
    let test = document.getElementById('scrollContainer')
    let item = document.getElementById('scrollContainer').children
    test.prepend(item[item.length - 1])
  }
  conditionCatFilter = false
  conditionCusineFilter = false
  categoryCheckList = []
  cuisineCheckList = []
  catCheckbokFunc(e: any, data) {
    if (e.target.checked) {
      this.categoryCheckList.push(parseInt(e.target.value))
      document.getElementById(data).style.display = 'inline-block'
    } else {
      let index = this.categoryCheckList.findIndex((ele) => ele == e.target.value)
      this.categoryCheckList.splice(index, 1)
      document.getElementById(data).style.display = 'none'
    }
    if (this.categoryCheckList.length != 0) {
      this.conditionCatFilter = true
    } else {
      this.conditionCatFilter = false
    }
  }
  cuisineCheckbokFunc(e: any, imgId) {
    if (e.target.checked) {
      document.getElementById(imgId).style.display = 'inline-block'
      this.cuisineCheckList.push(parseInt(e.target.value))
    } else {
      let index = this.cuisineCheckList.findIndex((ele) => ele == e.target.value)
      document.getElementById(imgId).style.display = 'none'
      this.cuisineCheckList.splice(index, 1)
    }
    if (this.cuisineCheckList.length != 0) {
      this.conditionCusineFilter = true
    } else {
      this.conditionCusineFilter = false
    }
  }
  getFilterResto() {
    let data = {
      lat: this.latitude,
      long: this.longitude,
      category_id: this.categoryCheckList,
      cuisine_id: this.cuisineCheckList,
      restaurant_name: ""
    }
    this.httpSv.getAllRestoByMutiCat(data).subscribe(res => {
      this.allrestaurant = res['result'].data;
      this.showAllResto = true;
      this.categoryCheckList.splice(0, this.categoryCheckList.length)
      this.cuisineCheckList.splice(0, this.cuisineCheckList.length)
      this.conditionCatFilter = false
      this.conditionCusineFilter = false
    }, (err: any) => {
      console.log(err);
      if (err.status == 401 || err.status == 500) {
        this.logout();
      }
      this.showAllResto = false;
      this._snackBar.open("No Restaurants Found!");
      setTimeout(() => {
        this._snackBar.dismiss();
      }, 2000);
    })
    // this.httpSv.getAllFilteredCategories(this.latitude, this.longitude, catId).subscribe((res: any) => {
    //   this.allrestaurant = res['result'].data;
    //   this.showAllResto = true;
    // }, (err: any) => {
    //   console.log(err);
    //   if (err.status == 401 || err.status == 500) {
    //     this.logout();
    //   }
    //   this.showAllResto = false;
    //   this._snackBar.open("No Restaurants Found!");
    //   setTimeout(() => {
    //     this._snackBar.dismiss();
    // }, 2000);

  }
  cuisineAllFlag = false
  viewAllCuisine() {
    this.cuisineAllFlag = !this.cuisineAllFlag
  }
  openAppStore(){
    window.open('https://apps.apple.com/in/app/foodbud/id1584641741')
  }
  openPlayStore(){
    window.open('https://play.google.com/store/apps/details?id=com.cms.foodbud')
  }
  goBackToMenu(){
    this.router.navigate(['/horizontal/food-menu'])
  }
}

@Component({
  selector: 'bottom-sheet-user-current-location',
  templateUrl: 'bottom-sheet-user-current-location.html',

})

export class BottomSheetuserCurrentLocation implements OnInit {
  UserCondition

  constructor(
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
    private router: Router,
    private bottomSheetRef: MatBottomSheetRef<BottomSheetuserCurrentLocation>,
    private _bottomSheet: MatBottomSheet,
    private changeDetectorRef: ChangeDetectorRef,
    public httpSv: HttpService,) {
    this.data = data
  }
  ngOnInit() {
    this.UserCondition = sessionStorage.getItem('access_token') ? true : false;
    this.userCurrentLocations = sessionStorage.getItem("userLocation");
    this.changeDetectorRef.detach();
  }

  close_popup() {
    this.bottomSheetRef.dismiss("User denied Geolocation");
  }

  grantLocation() {
    this.getLocation();
  }
  lng
  lat
  userCurrentLocations
  userCurrentLocation
  getLocation() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position: Position) => {
        if (position) {
          this.lat = position.coords.latitude;
          this.lng = position.coords.longitude;

          sessionStorage.setItem('lat', this.lat);
          sessionStorage.setItem('lng', this.lng);
          this.httpSv.getAllOfflineRestaurants(this.lat, this.lng).subscribe((res: any) => {
            if (res['status'] == "TRUE") {

              this.userCurrentLocations = res.result.data[0].visitorOrigin;
              this.userCurrentLocation = true;
              sessionStorage.setItem("userLocation", this.userCurrentLocations);
              this.bottomSheetRef.dismiss(this.userCurrentLocations);
            }
          }, (err: any) => {
            console.log(err)
          })
        }
      },
        (error: PositionError) => {
          this.bottomSheetRef.dismiss(error);
        });
    } else {
      swal.fire("Geolocation is not supported by this browser.");
    }
  }
  showLocationPage() {
    this.bottomSheetRef.dismiss();
    this.router.navigate(['/horizontal/change-location']);
  }
  private destroyed = false;
  ngOnDestroy() {
    this.destroyed = true;
    this.changeDetectorRef.detach();
  }

  triggerChangeDetection() {
    if (!this.destroyed) {
      this.changeDetectorRef.detach();
      this.changeDetectorRef.detectChanges();
      this.changeDetectorRef.detach();
    }
  }
  
}


@Component({
  selector: 'bottom-sheeet-confirm-location',
  templateUrl: 'bottom-sheet-confirm-location.html',

})

export class BottomSheetConfirmLocation implements OnInit {
  UserCondition
  location
  showDiv: boolean = false;
  constructor(
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
    private router: Router,
    private bottomSheetRef: MatBottomSheetRef<BottomSheetConfirmLocation>,
    private _bottomSheet: MatBottomSheet,
    public httpSv: HttpService,
    private changeDetectorRef: ChangeDetectorRef) {
    this.data = data
  }
  disableConfirmButton: boolean = false;
  ngOnInit() {
    this.changeDetectorRef.detach();
    this.showDiv = true;
    this.location = this.data.userCurrentLocation;
    if (this.location === 'User denied Geolocation') {
      this.disableConfirmButton = true;
    }
    this.changeDetectorRef.detectChanges();
    this.changeDetectorRef.detach();
  }

  close_popup() {
    this.bottomSheetRef.dismiss();
  }

  changeLocation() {
    this.bottomSheetRef.dismiss();
    this.router.navigate(['/horizontal/change-location']);
  }

  userCurrentLocation
  userCurrentLocations
  restoConditions
  confirmLocation() {
    this.userCurrentLocations = this.location;
    this.restoConditions = '1';
    this.userCurrentLocation = true;
    this.bottomSheetRef.dismiss(this.userCurrentLocations);
    sessionStorage.setItem("userLocation", this.userCurrentLocations)
  }

  private destroyed = false;
  ngOnDestroy() {
    this.destroyed = true;
    this.changeDetectorRef.detach();
  }

  triggerChangeDetection() {
    if (!this.destroyed) {
      this.changeDetectorRef.detach();
      this.changeDetectorRef.detectChanges();
      this.changeDetectorRef.detach();
    }
  }
}

@Component({
  selector: 'user-location-permission',
  templateUrl: 'user-location-permission.html',
})
export class UserLocationPermission implements OnInit {
  token
  constructor(
    public dialogRef: MatDialogRef<UserLocationPermission>,
    @Inject(MAT_DIALOG_DATA) public data,
    private changeDetectorRef: ChangeDetectorRef,
    private _bottomSheet: MatBottomSheet,
    private router: Router
  ) { }
  ngOnInit(): void {
    this.changeDetectorRef.detach();
  }

  imsure(): void {
    this.dialogRef.close();
    this.router.navigate(['/public/resto'])
  }

  retry() {
    this.dialogRef.close();
    let sheetRef = this._bottomSheet.open(BottomSheetuserCurrentLocation);
  }
  private destroyed = false;
  ngOnDestroy() {
    this.destroyed = true;
    this.changeDetectorRef.detach();
  }

  triggerChangeDetection() {
    if (!this.destroyed) {
      this.changeDetectorRef.detach();
      this.changeDetectorRef.detectChanges();
      this.changeDetectorRef.detach();
    }
  }
}